import { Alert } from 'react-bootstrap';

interface SuccessAlertProps {
  succeededJobs: Array<{ createdAt: string }>;
  formatDate: (date: string) => string;
}

export const SuccessAlert = ({ succeededJobs, formatDate }: SuccessAlertProps) => {
  if (!succeededJobs.length || !succeededJobs[0]) {
    return null;
  }

  return (
    <Alert variant="success" className="mb-4">
      AI Matching is finished as <strong>SUCCEEDED</strong> at {formatDate(succeededJobs[0].createdAt)}
    </Alert>
  );
};
